import { Component, ViewChild } from '@angular/core';
import { LogshipStatusComponent } from './logship-status.component';

/**
 * Admin Dashboard shell.
 *
 * Tab 0 (Logship) is the landing tab and renders eagerly. Tab 1 (Platform) holds the existing
 * QuickSight dashboard inside a `pTemplate="content"` template, which PrimeNG only instantiates
 * once its panel is first selected (`*ngIf="contentTemplate && (cache ? loaded : selected)"`).
 * That is what keeps the QuickSight embed - and the Snowflake query behind it - from being paid
 * for on every landing; it now costs only when someone actually opens Platform, and `cache`
 * keeps it from being re-embedded when tabbing back and forth.
 */
@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.scss'],
})
export class AdminDashboardComponent {
  static readonly LOGSHIP_TAB_INDEX = 0;

  activeTabIndex = AdminDashboardComponent.LOGSHIP_TAB_INDEX;

  /** Resolves once the Logship panel has rendered; it is the eager, default tab. */
  @ViewChild(LogshipStatusComponent) logshipStatus?: LogshipStatusComponent;

  /**
   * PrimeNG caches a rendered panel, so returning to Logship does not re-run its ngOnInit.
   * Refresh it explicitly instead, so the health shown is current on every view.
   */
  onTabChange(index: number): void {
    this.activeTabIndex = index;
    if (index === AdminDashboardComponent.LOGSHIP_TAB_INDEX) {
      this.logshipStatus?.reload();
    }
  }
}
